import { render } from "./QuizButton.vue?vue&type=template&id=b015e7d4&scoped=true"
import script from "./QuizButton.vue?vue&type=script&lang=js"
export * from "./QuizButton.vue?vue&type=script&lang=js"

import "./QuizButton.vue?vue&type=style&index=0&id=b015e7d4&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b015e7d4"]])

export default __exports__